import CoreVideoGrid from './CoreVideoGrid';

export { type CoreVideoGridProps } from './CoreVideoGrid';
export default CoreVideoGrid;
